import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=20d08a4b&scoped=true&"
import script from "./loginModal.vue?vue&type=script&lang=js&"
export * from "./loginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d08a4b",
  null
  
)

export default component.exports